import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributor = () => useQuery({ queryKey: [`distributor`], queryFn: async () => {
    const callback = await API.get(`/me`)
    return callback?.data
}, staleTime: 1000 * 60, gcTime: 1000 * 60 * 60 * 60 * 24 })

export default useDistributor